<template>
  <div>
    <h2>{{titulo}}</h2>
    <DataTable
      :loading="loading"
      :columns="columns"
      :rows="rows"
      :paging=false
      :buttons=false
      :searching="false"
      :td-style-class="tdStyleClassFn"
      clases="table-bordered nowrap">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'tiempo_e'">
          {{ props.row.tiempo_e }} dias
        </span>
        <span v-else-if="props.column.field == 'tiempo_t'">
          {{ props.row.tiempo_t }} dias
        </span>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { inspeccionService, globales } from '@/services';
import { utils } from '@/helpers';

export default {
  props:['filtro','titulo'],
  data(){
    return {
      data: this.filtro,
      globales,
      loading: true,
      columns:[
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Por asignar', field: 'r'},
        {label: 'En ejecución', field: 'e'},
        {label: 'Terminados', field: 't'},
        {label: 'Promedio Por asignar > En ejecución', field: 'tiempo_e'},
        {label: 'Promedio En ejecución > Terminado', field: 'tiempo_t'},
        ],
      rows:[],
    }
  },
  mounted(){
    if(typeof(this.filtro) === 'undefined'){
      this.data =  {
        fecha_i: new Date(2000,0,1),
        fecha_t: new Date(2030,0,1),
        mostrar_terminados:'N',
        id_sucursal: this.$store.state.usuario.sucursales.map((element) => element.id_sucursal)
      }

      this.columns = [
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Por asignar', field: 'r'},
        {label: 'En ejecución', field: 'e'},
        {label: 'Promedio Por asignar > En ejecución', field: 'tiempo_e'},
      ];

      this.cargarDatos();
    }
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      inspeccionService.getInspeccionIndicadoresSucursal({
        id_usuario: this.$store.state.usuario.id_usuario,
        perfiles: utils.mapAtributo(this.$store.state.usuario.perfiles, 'id_perfil'), 
        id_sucursal: Array.isArray(this.data.id_sucursal) ? this.data.id_sucursal : this.data.id_sucursal.split(','),
        categorias: utils.mapAtributo(this.$store.state.usuario.categorias,'id_categoria'),
        fecha_i: utils.DateToFecha(this.data.fecha_i, 'dd-mm-yyyy'),
        fecha_t: utils.DateToFecha(this.data.fecha_t, 'dd-mm-yyyy'),
        mostrar_terminados:this.data.mostrar_terminados == null ? 'S':this.data.mostrar_terminados
      }).then(data => {
        this.rows = data.data;

        this.loading = false;
      });
    },
    tdStyleClassFn(row, column) {
      if(column.field == 'r'){
        return "td-yellow";
      }
      if(column.field == 'e' || column.field == 'tiempo_e'){
        return "td-blue";
      }
      if(column.field == 't' || column.field == 'tiempo_t'){
        return "td-green";
      }
    },
  }
}
</script>

<style scoped>
</style>
